/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ goods: NonNullable<unknown> }} Carrier_Form_Cod_Override_HintInputs */

const vi_carrier_form_cod_override_hint = /** @type {(inputs: Carrier_Form_Cod_Override_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ trống để dùng số còn nợ của đơn (${i?.goods}đ). Chỉ nhập tiền hàng. Nếu người nhận trả cước, Viettel Post tự cộng cước.`)
};

/**

* @param {Carrier_Form_Cod_Override_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override_hint = /** @type {((inputs: Carrier_Form_Cod_Override_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Override_HintInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override_hint(inputs)
});